import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	copyLinkTooltipLabel: {
		id: 'hub-home.action-bar.copy-link-tooltip-label',
		defaultMessage: 'Copy link',
		description: 'Tooltip for the button to copy content URL',
	},
	copiedLinkTooltipLabel: {
		id: 'hub-home.action-bar.copied-link-tooltip-label',
		defaultMessage: 'Copied!',
		description: 'Tooltip for the button that shows content URL has been copied',
	},
	successIconLabel: {
		id: 'hub-home.action-bar.copy-link-success-icon-label',
		defaultMessage: 'Success icon',
		description: 'Label for the success icon used in the button to copy content URL',
	},
	linkIconLabel: {
		id: 'hub-home.action-bar.copy-link-link-icon-label',
		defaultMessage: 'Link icon',
		description: 'Label for the link icon used in the button to copy content URL',
	},
	copyLinkButtonLabel: {
		id: 'hub-home.action-bar.copy-link-button-label',
		defaultMessage: 'Copy Link Button',
		description: 'Label for the button that copies content URL',
	},
});

export default messages;

